import { render, staticRenderFns } from "./change-language.vue?vue&type=template&id=171dd4e0&scoped=true&"
import script from "./change-language.vue?vue&type=script&lang=js&"
export * from "./change-language.vue?vue&type=script&lang=js&"
import style0 from "./change-language.vue?vue&type=style&index=0&id=171dd4e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171dd4e0",
  null
  
)

export default component.exports